import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const CustomerHeaderHoc = (WrappedComponent) => {
  const customerOptions = [
    "Invoice",
    "Receive payment",
    "Statement",
    "Estimate",
    "Credit memo",
    "Sales receipt",
    "Shipping label",
    "Refund receipt",
    "Delayed credit",
    "Delayed charge",
    "Add client",
  ];
  const returnUrl = (option) => {
    switch (option) {
      case "Invoice":
        return "/Invoice_new";
      case "Receive payment":
        return "/Receive_payment";
      case "Statement":
        return "/Statement";
      case "Estimate":
        return "/Estimate";
      case "Credit memo":
        return "/Credit_memo";
      case "Sales receipt":
        return "/Sales_receipt";
      case "Shipping label":
        return "/Shipping_label";
      case "Refund receipt":
        return "/Refund_receipt";
      case "Delayed credit":
        return "/Delayed_credit";
      case "Delayed charge":
        return "/Delayed_charge";
      case "Add client":
        return "/Add_client";
      default:
        return "/";
    }
  };

  return function CustomerHeader(props) {
    const [activeTab, setActiveTab] = useState(0);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
      const currentIndex = customerOptions.findIndex((option) => returnUrl(option) === location.pathname);
      if (currentIndex !== -1) {
        setActiveTab(currentIndex);
      }
    }, [location.pathname]);

    const handleClick = (index, option) => {
      setActiveTab(index);
      navigate(returnUrl(option));
    };

    return (
      <div>
        <main id="maincontent" className="pt-4 ">
          <div>
            <div className="mx-4 sm:mx-10 mb-3 mt-6 sm:mt-10 px-3 sm:pl-5 border border-[#D6D3D3] bg-white items-center rounded">
              <ul className="flex flex-wrap z-10 text-16 sm:text-16 sm:pt-1 sm:gap-4 md:gap-8">
                {customerOptions.map((option, index) => (
                  <li
                    key={option}
                    onClick={() => handleClick(index, option)}
                    className={`cursor-pointer py-1 ${
                      activeTab === index
                        ? "text-[#203C50] font-500 border-b border-[#203C50]"
                        : "text-[#848687] font-400"
                    }`}
                  >
                    {option}
                  </li>
                ))}
              </ul>
            </div>

            <WrappedComponent {...props} />
          </div>
        </main>
      </div>
    );
  };
};

export default CustomerHeaderHoc;
